import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import * as pgrid from 'projection-grid';
import { recommendationInlineAction } from '@bingads-webui-campaign/recommendation-inline-action';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { perfMarkerPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import {
  showContextualAttribute,
  hideContextualAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import {
  VISUAL_TYPES,
  CONTEXTUAL_ENTITY_TYPE,
  RECOMMENDATION_TYPES,
  ADINSIGHT_LOG_ACTION_TYPE,
} from '@bingads-webui-campaign/recommendation-core';
import { AdvisorChart } from '@bingads-webui-campaign-react/advisor-chart';

import {
  DeterministicWrapperView,
  DeterministicViewForBackBoneView,
} from '@bingads-webui/deterministic-wrapper-view';
import { showPopup } from '@bingads-webui/automatic-positioning-popover';


import { isPopupEditorEnabledRecommendationType, getSearchTermChartData } from './const';
import { projectionGridEnableWithSelection } from './new-additional-plugins';
import { recommendationToolBarPlugin } from './grid-toolbar-plugin';

export class NewRecommendationsGrid extends DeterministicWrapperView {
  viewFactory({
    i18n,
    deps,
    config,
    logOpportunityEvent,
    recommendationType,
    recommendationService,
    downloadService,
    isMCC = false,
    crossPageSelectPlugin,
    newToolBarPlugin,
    onEvent,
    readOnly,
    compact,
    s$i18n,
    newI18n,
  }) {
    this.isMCC = isMCC;
    this.onEvent = onEvent;
    this.deps = deps;
    this.i18n = i18n;
    this.logOpportunityEvent = logOpportunityEvent;
    this.recommendationType = recommendationType;
    this.recommendationService = recommendationService;
    this.downloadService = downloadService;
    this.timerForPopupContextualAttribute = null;
    this.readOnly = readOnly;
    this.compact = compact || false;
    this.s$i18n = s$i18n;
    this.newI18n = newI18n;
    this.imageUrl = [];
    this.timerForStockUXCall = null;
    this.selectableFunc = null;

    this.gridFactory = pgrid.factory({ vnext: true })
      // For accurate grid init latency, PerfMarkerPlugin should be the first plugin to load.
      .use(perfMarkerPlugin)
      .use(recommendationInlineAction)
      .use(newToolBarPlugin)
      .use(assistedSelectionPlugin)
      .use(projectionGridEnableWithSelection)
      .use(uiBlockerPlugin)
      .use(paginationPlugin)
      .use(crossPageSelectPlugin.plugin)
      .use(recommendationToolBarPlugin);

    if (isPopupEditorEnabledRecommendationType(recommendationType)) {
      this.gridFactory = this.gridFactory
        .use(editablePlugin);
    }

    this.grid = this.gridFactory.create(config);

    this.grid.gridView.once('didReload', () => {
      this.onEvent('loaded');
    });
    this.grid.gridView.once('refreshSummary', () => {
      this.onEvent('refreshSummary');
    });

    this.renderStockImagePreview = (row, src) => {
      $(`tbody tr:nth-child(${row}) .suggested-image-extension-preview-column img`)
        .attr('src', src);
      $(`tbody tr:nth-child(${row}) .loadContainer`).remove();
    };

    this.renderNoImagePreview = (row) => {
      $(`tbody tr:nth-child(${row}) .suggested-image-extension-preview-column .previewImage`).empty();
      $(`tbody tr:nth-child(${row}) .suggested-image-extension-preview-column .previewImage`)
        .append('<div><button><span class="iconba iconba-Add inline-action-panel"/></button></div>');
      $(`tbody tr:nth-child(${row}) .suggested-image-extension-preview-column .previewTexts`).empty();

      const noImageText = this.newI18n.getString(_TL_('Image preview is not currently available. Please select the "+" thumbnail or the Add image extension button to add an image extension.'));
      $(`tbody tr:nth-child(${row}) .suggested-image-extension-preview-column .previewTexts`)
        .append(`<div class="noImage"><span>${noImageText}</span></div>`);
      $(`tbody tr:nth-child(${row}) .inline-action-image-extension-column .actionContainer`).empty();

      const actionText = this.newI18n.getString(_TL_('Add image extension'));
      $(`tbody tr:nth-child(${row}) .inline-action-image-extension-column .actionContainer`)
        .append(`<button class="btn btn-primary inline-action-panel">${actionText}</button>`);
      $(`tbody tr:nth-child(${row}) .loadContainer`).remove();
    };

    this.logOpportunity = (opportunity) => {
      const context = opportunity.ImageSourceStr === 'StockImage' ? {
        ImageSource: opportunity.ImageSourceStr,
        ShutterstockQuery: _.first(_.first(opportunity.Opportunities).StockImages).Query,
        ShutterstockTotalCount: _.first(_.first(opportunity.Opportunities).StockImages).TotalCount,
        ShutterstockImageId: _.first(_.first(opportunity.Opportunities).StockImages).ImageId,
      } : {
        ImageSource: opportunity.ImageSourceStr,
      };

      this.logOpportunityEvent({
        opportunityId: opportunity.Opportunities[0].OpportunityId,
        campaignId: opportunity.Target.CampaignId,
        type: this.recommendationType,
        action: ADINSIGHT_LOG_ACTION_TYPE.VIEW,
        accountId: opportunity.Target.AccountId,
        context,
      });
    };

    this.getStockImage = () => {
      const item = this.grid.gridView.itemArray;
      _.each(item, (eachItem, index) => {
        const data = _.first(eachItem.Opportunities);
        const row = index + 2; // The row index of first item in grid tbody start from #2.
        _.first(eachItem.Opportunities).ImageSourceStr = eachItem.ImageSourceStr;
        if (!_.isEmpty(data.StockImages)) {
          this.recommendationService.getStockImageUrl(_.first(data.StockImages).Query)
            .then(
              (resdata) => {
                _.first(_.first(eachItem.Opportunities).StockImages).TotalCount = resdata['@odata.count'];                      // eslint-disable-line
                if (!_.isEmpty(resdata.value)) {
                  _.first(_.first(eachItem.Opportunities).StockImages).ImageId = Number(_.first(resdata.value).Id);             // eslint-disable-line
                  _.first(_.first(eachItem.Opportunities).StockImages).ThumbnailURL = _.first(resdata.value).SmallThumbnail.Url;       // eslint-disable-line
                  this.renderStockImagePreview(row, _.first(resdata.value).SmallThumbnail.Url);
                  this.imageUrl.push({ Url: _.first(resdata.value).SmallThumbnail.Url, index });
                } else {
                  this.renderNoImagePreview(row);
                  this.imageUrl.push({ Url: '', index });
                }

                this.logOpportunity(eachItem);
                setTimeout(() => {
                  if ($('tbody .loadContainer').length === 0) {
                    this.grid.gridView.set({ selection: _.defaults({ selectable: this.selectableFunc }) });  // eslint-disable-line
                  }
                }, 200);
              },
              (err) => {
                this.renderNoImagePreview(row);
                this.imageUrl.push({ Url: '', index });

                this.logOpportunity(eachItem);
                this.recommendationService.handleAjaxError(err, 'getStockImageUrl');
                setTimeout(() => {
                  if ($('tbody .loadContainer').length === 0) {
                    this.grid.gridView.set({ selection: _.defaults({ selectable: this.selectableFunc }) });  // eslint-disable-line
                  }
                }, 200);
              }
            );
        } else if (!_.isEmpty(data.WebsiteImages)) {
          this.logOpportunity(eachItem);
        }
      });

      this.grid.gridView.on('didRedraw', () => {
        _.each(this.imageUrl, (imageUrl) => {
          const row = imageUrl.index + 2;
          if (imageUrl.Url !== '') {
            this.renderStockImagePreview(row, imageUrl.Url);
          } else {
            this.renderNoImagePreview(row);
          }
        });
      });
    };

    if (this.recommendationType === RECOMMENDATION_TYPES.IMAGE_EXTENSION && this.deps.permissions.IsRecommendationGetShutterStockImageFromUXEnabled) {  // eslint-disable-line
      this.selectableFunc = this.grid.gridView.get('selection').selectable;
      this.grid.gridView.on('willReload', () => {
        clearTimeout(this.timerForStockUXCall);
      });

      this.grid.gridView.on('didReload', () => {
        this.imageUrl = [];

        this.grid.gridView.set({ selection: _.defaults({ selectable: this.selectableFunc }) });
        this.grid.gridView.once('didRedraw', () => {
          _.each(this.grid.gridView.itemArray, (eachItem) => {
            if (eachItem.ImageSourceStr === 'StockImage') {
              this.grid.gridView.set({ selection: _.defaults({ selectable: () => {} }) });
            }
          });

          if (this.grid.pagination.pageNumber === 0) {
            this.getStockImage();
          } else {
            this.timerForStockUXCall = setTimeout(() => {
              this.getStockImage();
            }, 1000);
          }
        });
      });
    }

    return this.grid.gridView;
  }

  get events() {
    const popupEvents = {
      'mouseover .grid-column-accountName .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-accountName .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-campaignName .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-campaignName .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-adGroupName .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-adGroupName .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-keyword .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-keyword .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-BidAdjustmentTodo .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-BidAdjustmentTodo .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-BudgetDelta .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-BudgetDelta .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-blockedKeywordList .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-blockedKeywordList .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-removeNKW .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-removeNKW .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-whatyoucando .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-whatyoucando .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-setupConversionTrackingToDo .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-setupConversionTrackingToDo .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-goalName .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-goalName .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-goal-setting .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-goal-setting .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .grid-column-generateFrom .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-generateFrom .contextual-tooltip': 'hideContextualAttributePopup',
      'mouseover .suggested-improve-mma-preview-column .contextual-tooltip': 'showContextualAttributePopup',
      'mouseleave .suggested-improve-mma-preview-column': 'hideContextualAttributePopup',
      'mouseover .grid-column-goalSetting .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .grid-column-goalSetting .contextual-tooltip': 'hideContextualAttributePopup',
    };

    const otherEvents = {
      'click .grid-column-accountName .contextual-tooltip': 'router',
      'click .grid-column-campaignName .contextual-tooltip': 'router',
      'click .grid-column-campaignAdGroupName .campaign': 'router',
      'click .grid-column-BudgetDelta .contextual-tooltip': 'router',
      'click .grid-column-BidAdjustmentTodo .contextual-tooltip': 'router',
      'click .grid-column-adGroupName .contextual-tooltip': 'router',
      'click .grid-column-removeNKW .contextual-tooltip': 'router',
      'click .grid-column-whatyoucando .contextual-tooltip': 'router',
      'click .grid-column-setupConversionTrackingToDo .contextual-tooltip': 'router',
      'click .more-tooltip .more-link': 'showClickableTooltip',
      'click .more-tooltip .close-button': 'hideClickableTooltip',
      'click .more-tooltip .more-top-search-term': 'showTopSearchTermChart',
      'change .match_type_inline_selection .match-type-select': 'updateMatchType',
    };

    if (this.compact) {
      return otherEvents;
    }

    return {
      ...popupEvents,
      ...otherEvents,
    };
  }

  remove() {
    if (this.grid) {
      if (this.grid.toolbar && this.grid.toolbar.gridToolbarGroup) {
        this.grid.toolbar.gridToolbarGroup.remove();
        this.grid.toolbar = null;
      }
    }

    super.remove();
  }

  getTargetEnity(event) {
    const key = this.grid.gridView.keyOfElement(event.target);

    return this.grid.gridView.itemWithKey(key);
  }

  onWunderbarChange() {
    this.grid.gridView.monitorViewportChange(1500, 15);
  }

  router(e) {
    const target = $(e.target);
    // only account or campaign or adgroup contextual attribute can be clicked to redirect
    if (!_.contains([
      CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      CONTEXTUAL_ENTITY_TYPE.ADGROUP,
      CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
    ], target.data('type'))) { // eslint-disable-line
      return;
    }
    const levelAt = target.data('type');
    const entityid = target.data('entityid');
    const campaignId = target.data('entitycampaignid');
    const { scope } = this.recommendationService;
    const key = $(e.target).parents('tr[data-key]').data('key') || $(e.target).parents('tr[key]').attr('key');
    const recommendation = this.grid.gridView.itemWithKey(key);
    const accountId = recommendation.Target.AccountId;

    if (isPopupEditorEnabledRecommendationType(this.recommendationType)
      && this.recommendationType !== RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS
      && this.recommendationType !== RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID
      && levelAt === levelAtConstant.ADGROUP) {
      return;
    }
    if (levelAt !== scope.levelAt) {
      const scopedata = {
        ...scope,
        levelAt,
        adGroupId: entityid,
        campaignId: campaignId || entityid,
        accountId,
      };
      this.onEvent('updateScope', scopedata);
    }
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    const { scope } = this.recommendationService;
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.recommendationType,
        isMCC: this.isMCC,
        self: this,
        scope,
        recommendationService: this.recommendationService,
        s$i18n: this.s$i18n,
        newI18n: this.newI18n,
      });
    }, 500);
  }

  showClickableTooltip(e) {
    const target = $(e.target);
    const tooltipContainer = target.parent().find('.more-tooltip-container');
    const {
      top, left, height, width,
    } = $(e.target)[0].getBoundingClientRect();

    const contentView = new DeterministicViewForBackBoneView({
      view: new (Backbone.View.extend({
        render() {
          this.$el.html(_.first(tooltipContainer).outerHTML); // this.$el is a jQuery wrapped el var
          return this;
        },
        remove() {
          if (document.body.contains(this.el)) {
            ReactDOM.unmountComponentAtNode(this.el);
          }
          Backbone.View.prototype.remove.call(this);
        },
      }))().render(),
    });

    const container = $('.recommendation-grid');
    const popupOptions = {
      positioningMethod: 'fit',
      positioningOptions: {
        threshold: 0.5,
        anchorPosition: {
          height,
          width,
          left: left - container.offset().left,
          top: top - container.offset().top,
        },
      },
      contentView,
      classes: ['popup--custom'],
      container,
    };

    return showPopup(popupOptions);
  }

  showTopSearchTermChart(e) {
    const target = $(e.target);
    // Get searchTermList from data-searchtermlist
    const searchTermList = target.data('searchtermlist');
    let chart = null;
    const visualType = VISUAL_TYPES.SEARCH_TERMS_CHART;
    const visualData = getSearchTermChartData(searchTermList);

    let smartTopSearchTermChartWidth = 640;
    // Need wider popup window for some languages to resolve truncated string
    if (!_.isUndefined(this.i18n.getString('AuctionInsights_ColumnName_SearchTerms'))
      && this.i18n.getString('AuctionInsights_ColumnName_SearchTerms').length > 30) {
      smartTopSearchTermChartWidth = 900;
    }

    // According to highcharts document the width is calculated from
    // the offset width of the containing element.
    // AdvisorChart doesn't set width of chart options, so it will rely on the
    // width of chart container.
    // A container will fixed width is needed here to let chart render with
    // this fixed width, otherwise it will use grid width.
    chart = (
      <div
        className="search-term-chart-container"
        style={{ width: smartTopSearchTermChartWidth }}
      >
        <AdvisorChart
          i18n={this.i18n}
          type="RecommendationCard"
          subType={visualType}
          {...visualData}
        />
      </div>
    );

    const {
      top, left, height, width,
    } = $(e.target)[0].getBoundingClientRect();

    const contentView = new DeterministicViewForBackBoneView({
      view: new (Backbone.View.extend({
        render() {
          ReactDOM.render(
            chart,
            this.el
          );
          return this;
        },
        remove() {
          if (document.body.contains(this.el)) {
            ReactDOM.unmountComponentAtNode(this.el);
          }
          Backbone.View.prototype.remove.call(this);
        },
      }))().render(),
    });

    const container = $('.recommendation-grid');
    const popupOptions = {
      positioningMethod: 'fit',
      positioningOptions: {
        threshold: 0.5,
        anchorPosition: {
          height,
          width,
          left: left - container.offset().left,
          top: top - container.offset().top,
        },
      },
      contentView,
      classes: ['popup--custom'],
      container,
    };

    return showPopup(popupOptions);
  }

  updateMatchType(e) {
    const key = $(e.target).parents('tr[data-key]').data('key');
    const recommendation = this.grid.gridView.itemWithKey(key);
    const index = e.target.selectedIndex;
    _.first(recommendation.Opportunities).NewMatchType = Number(e.target.options[index].value);

    // Append the current selected one into existing selected ones.
    const selectedKeys = this.grid.gridView.selectedKeys();
    if (!_.contains(selectedKeys, key)) {
      selectedKeys.push(key);
    }
    this.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
  }

  hideClickableTooltip(e) {
    const target = $(e.target);
    target.parents('.more-tooltip-container').hide();

    // Remove click listener from window
    $(window).off('click');
  }

  onClickGlobal(e) {
    const target = $(e.target);
    if (target.parent().length > 0 &&
      target.parents('.more-tooltip-container').length === 0 &&
      !target.parent().hasClass('more-tooltip') &&
      !target.hasClass('more-tooltip-container')) {
      $('.more-tooltip-container').hide();

      // Remove click listener from window
      $(window).off('click');
    }
  }

  get className() { return 'recommendations-grid-view'; }
}
